/**
 * Internal depedencies
 */
import { addWidgetToLayout } from 'state/dashboard-layouts/actions';
import { getLayoutId } from 'state/dashboard/selectors';

export default (widgetId) => (dispatch, getState) => {
	dispatch(addWidgetToLayout(getLayoutId(getState()), widgetId));
};
